var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cards-view',{attrs:{"fanzoneTypesIds":[4],"url":"fanzone-roadtour"}})}
var staticRenderFns = []

export { render, staticRenderFns }